import $ from 'jquery';
import { Dropdown } from 'fjs/foundation.dropdown';

const dropdowns = Array.from(document.getElementsByClassName('hero-home__dropdown'));

const initDropdowns = () => {
  dropdowns.forEach(dropdown => {
    const pane = dropdown.querySelector('.dropdown-pane');
    $(pane).foundation('_destroy');
    pane.setAttribute('style', '');
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    new Dropdown($(pane), {
      hover: !isTouch,
      hoverPane: !isTouch,
      hoverDelay: 100,
      vOffset: window.matchMedia('(max-width: 1023px)').matches ? 0 : 20,
    });
  });
}

window.addEventListener('load', initDropdowns);
